import { DataBean } from "../DataBean";

export class EcmDocument extends DataBean {


    public async fireSigningDocumentFlow(idDocument: number, mnemonic: string|null, documentDate: any,idSignAndApprovalPanel:number,idEmployee:number): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "String_fireSigningDocumentFlow_Number_String_java.util.Date_Number_Number",
            [idDocument,mnemonic,documentDate,idSignAndApprovalPanel,idEmployee]
        );
    }
    public async createEcmDocumentForFlowControl(idSignAndApprovalPanel:number,idAccount:number,description:string,items:any,idProcess:number,processDate:any,idEmployee:number): Promise<any> {
        return this.getCustomService("QuickDataERPCore", 
            "com.quickdataerp.bean.accountant.AccountantDocument_createEcmDocumentForFlowControl_Number_Number_String_java.util.List_Number_java.util.Date_Number",
            [idSignAndApprovalPanel,idAccount,description,items,idProcess,processDate,idEmployee]
        );
    }
    public async getPayrollAnnualDataReport(year:number): Promise<any> {
        return this.getCustomService("QuickDataERPCore", 
            "java.util.List_getPayrollAnnualDataReport_Number",
            [year]
        );
    }


}